// Execution role (maker/taker) is reported differently per venue: Deribit
// sets `user_role` ('maker'/'taker'); OKX omits that and instead carries the
// role in `execType` ('M'/'T'). Normalise both to one vocabulary so the
// per-row Side tag (transactions-table) and the maker/taker volume bar
// (transactions-metrics) classify OKX rows identically and can't drift.
export type ExecRole = 'maker' | 'taker';

export const normalizeExecRole = (raw?: string | null): ExecRole | null => {
  const r = (raw ?? '').toString().trim().toLowerCase();
  if (r === 'maker' || r === 'm') return 'maker';
  if (r === 'taker' || r === 't') return 'taker';
  return null;
};
